export interface SampleInputs {
  python: string;
  java: string;
  javascript: string;
  typescript: string;
  cobol: string;
  json: string;
  sql: string;
  xml: string;
}

export const sampleInputs: SampleInputs = {
  python: `def hello_world():
    print("Hello, World!")

hello_world()`,

  java: `public class HelloWorld {
    public static void main(String[] args) {
        System.out.println("Hello, World!");
    }
}`,

  javascript: `function helloWorld() {
    console.log("Hello, World!");
}

helloWorld();`,

  typescript: `function helloWorld(): void {
    console.log("Hello, World!");
}

helloWorld();`,

  cobol: `IDENTIFICATION DIVISION.
PROGRAM-ID. HELLO.
PROCEDURE DIVISION.
DISPLAY "Hello, World!".
STOP RUN.`,

  json: `{
    "name": "John Doe",
    "age": 30,
    "city": "New York",
    "hobbies": ["reading", "coding"]
}`,

  sql: `SELECT name, age, city
FROM users
WHERE age > 25
ORDER BY name;`,

  xml: `<?xml version="1.0" encoding="UTF-8"?>
<person>
    <name>John Doe</name>
    <age>30</age>
    <city>New York</city>
</person>`,
};

export default sampleInputs;
